import React, { useEffect, useState } from 'react';
import TrendCard from '../TrendCard';
import GoogleTrendsChart from './GoogleTrendsChart';
import { getStudioGoogleTrends } from '@op/services';
import { addWithoutSingleData } from '@op/utils';
import { canRequest } from '../utils';
import { scoreFormat } from '@op/utils/value';

// 辅助函数：减少一天 T-1
function subtractOneDay(dateString: string): string {
  const date = new Date(dateString);
  date.setDate(date.getDate() - 1);
  return date.toISOString();
}

// 辅助函数：格式化数据
function formatTimelineData(timeline: any[]) {
  return (timeline || []).map((item: { value: any; }) => ({
    ...item,
    count: item.value,
  }));
}

interface IProps {
  // 筛选器
  filter: any;
  // 竞品浮窗是否延时请求
  isDelay?: boolean;
  config?: { 
    // 竞品浮窗是否延时请求
    isDelay: boolean;
    className: string;
    style: React.CSSProperties;
  }; 
};

export default function GoogleTrends(props: IProps) {
  const {filter, isDelay,  config} = props || {};
  const isDelayVal = isDelay ? isDelay : config?.isDelay;
  const { className, style } = config || {};
  const [newValue, setNewValue] = useState<Array<{ count: number; time: string; }>>([]);
  const [oldValue, setOldValue] = useState<Array<{ count: number; time: string; }>>([]);
  const [loading, setLoading] = useState(false);

  function requestServerData() {
    setLoading(true);
    getStudioGoogleTrends(filter)
      .then((data: any) => {
        const {
          old_timeline_of_end_time,
          old_timeline_of_start_time,
          old_timeline,
          timeline,
          timeline_of_end_time,
          timeline_of_start_time,
        } = data || {};

        // 默认筛选器结束日期T-1
        const old_end_time = filter.isConfirm ? old_timeline_of_end_time : subtractOneDay(old_timeline_of_end_time);
        const new_end_time = filter.isConfirm ? timeline_of_end_time : subtractOneDay(timeline_of_end_time);

        const oldTimeline = addWithoutSingleData(
          old_timeline_of_start_time,
          old_end_time,
          filter.date_type,
          formatTimelineData(old_timeline),
          { count: 0 },
        );

        const newTimeline = addWithoutSingleData(
          timeline_of_start_time,
          new_end_time,
          filter.date_type,
          formatTimelineData(timeline),
          { count: 0 },
        );

        setNewValue(newTimeline);
        setOldValue(oldTimeline);
      })
      .catch(() => {
      })
      .finally(() => {
        setLoading(false);
      });
  }

  useEffect(() => {
    const shouldRequest = canRequest(filter);
    if (shouldRequest) {
      requestServerData();
    }
  }, [filter]);

  return (
    <div className={className} style={style}>
      <TrendCard
        title="Google Trends"
        isLeft
        loading={loading}
        moduleType="google_trends"
        loadingHeight={160}
        filter={filter}
        formatValue={(value: number) => scoreFormat(value, 0)}
        noJump
        className="dbh-trend-card--google"
        isDelay={isDelayVal}
      >
        <GoogleTrendsChart
          leftTitle={'Index'}
          valueKey="count"
          newValue={newValue}
          filter={filter}
          oldValue={oldValue}
          list={[
            {
              name: 'Current period',
              color: '#5086F3',
            },
            {
              name: 'Previous period',
              color: '#69D19C',
            },
          ]}
          height={150}
        />
      </TrendCard>
    </div>
  );
}
